import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    zIndex: 3,
    display: 'flex',
    flexDirection: 'row',
    position: 'absolute',
    right: theme.spacing(3.75),
    margin: theme.spacing(1.875),

    '& .MuiButtonBase-root': {
      borderRadius: '50%',
      fontSize: theme.spacing(3),
      backgroundColor: 'rgba(34, 35, 39, 0.90)',
      margin: theme.spacing(0, 1.25, 0, 0),

      '&:last-child': {
        margin: theme.spacing(0),
      },
    },
  },

  fullscreen: {
    right: theme.spacing(0),
  },
}));
